import { routeTypes } from "../hooks/useSystemRoutes"

import workstationSidebarConfig from "../layouts/workstation/SidebarConfig"
import retailSidebarConfig from "../layouts/retail/SidebarConfig"
import adminSidebarConfig from "../layouts/admin/SidebarConfig"
import customerSidebarConfig from "../layouts/customer/SidebarConfig"
import memberSidebarConfig from "../layouts/member/SidebarConfig"
import driverSidebarConfig from "../layouts/driver/SidebarConfig"

import { SidebarLogo } from "../components/@layouts/SidebarLogo"

import { customSiderbars } from '../customization'
import { getSystemLogo, logoTypes } from "./logoConfigs"

export const getSidebarConfigs = ({ routeType }) => {

  let config;

  if (routeType === routeTypes.admin) {
    config = customSiderbars?.admin && customSiderbars.admin.length ? customSiderbars.admin : adminSidebarConfig
  }

  if (routeType === routeTypes.retail) {
    config = customSiderbars?.retail && customSiderbars.retail.length ? customSiderbars.retail : retailSidebarConfig
  }

  if (routeType === routeTypes.workstation) {
    config = customSiderbars?.workstation && customSiderbars.workstation.length ? customSiderbars.workstation : workstationSidebarConfig
  }

  if (routeType === routeTypes.customer) {
    config = customSiderbars?.customer && customSiderbars.customer.length ? customSiderbars.customer : customerSidebarConfig
  }

  if (routeType === routeTypes.member) {
    config = customSiderbars?.member && customSiderbars.member.length ? customSiderbars.member : memberSidebarConfig
  }

  if (routeType === routeTypes.driver) {
    config = customSiderbars?.driver && customSiderbars.driver.length ? customSiderbars.driver : driverSidebarConfig
  }

  return config
}

export const getRouteTypeLabel = ({ routeType, t }) => {

  let routeTypeLabel = '';

  // translate the route type
  if (routeType === routeTypes.admin) {
    routeTypeLabel = t("routeAdmin")
  }
  if (routeType === routeTypes.workstation) {
    routeTypeLabel = t("routeWorkstation")
  }
  if (routeType === routeTypes.customer) {
    routeTypeLabel = t("routeCustomer")
  }
  if (routeType === routeTypes.retail) {
    routeTypeLabel = t("routeRetail")
  }
  if (routeType === routeTypes.member) {
    routeTypeLabel = t("routeMember")
  }
  if (routeType === routeTypes.driver) {
    routeTypeLabel = t("routeDriver")
  }

  return routeTypeLabel

}

export const getSidebarLogo = ({ routeType, t }) => {

  const logo = getSystemLogo({ routeType, logoType: logoTypes.sidebar })

  let routeTypeLabel = getRouteTypeLabel({ routeType, t })

  return <SidebarLogo routeType={routeTypeLabel} LogoComponent={logo.component} />
}